import React from 'react';
import Button from '../../../components/forms/Button';
import DeleteIcon from '@material-ui/icons/Delete';

const ModalButtons = ({ cancelAction, deleteAction, confirmAction, inactive, confirmLabel }) => (
    <div className="ckp-admin-modal-forms-buttons">
        {deleteAction ? (
            <a className="ckp-admin-modal-forms-button  ckp-buttons-text is-warning is-left" onClick={deleteAction}>
                <DeleteIcon /> Delete
            </a>
        ) : null}
        <a onClick={cancelAction} className="ckp-admin-modal-forms-button ckp-buttons-text is-warning">
            Cancel
        </a>
        <Button
            className="ckp-admin-modal-forms-button is-auto-width"
            type="button"
            inactive={inactive}
            onClick={confirmAction}
            label={confirmLabel || 'Save'}
        />
    </div>
);

export default ModalButtons;



// WEBPACK FOOTER //
// ./src/components/admin/forms/ModalButtons.js